
<span :class="pillClass">
  <slot />
</span>
